<a (click)=toggleTheme() class="header-nav nav-link nav-icon-text">
  <cds-icon [attr.shape]="theme === 'dark' ? 'sun' : 'moon'"></cds-icon>
  <span class="nav-text">{{ themeText }}</span>
</a>
